import { ErrorBoundary } from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { queryClient } from '~/data/queryClient';

import { App } from './App';

// App entry point: only reachable by actually booting the SPA, so it is covered
// by e2e rather than unit tests. Flagged on CRAP (coverage), not on branching.
// fallow-ignore-next-line complexity
async function bootstrap() {
  /**
   * Start MSW only in Vite dev server.
   * Built dev deployments also use VITE_ENV=development, but must keep the PWA service worker in control.
   * Otherwise the mockServiceWorker intercepts the requests and the PWA never updates.
   **/
  if (
    import.meta.env.DEV &&
    import.meta.env.VITE_ENV === 'development' &&
    import.meta.env.VITE_MOCK_ENDPOINTS === 'true'
  ) {
    try {
      const { startMockWorker } = await import('./mocks/start');
      await startMockWorker();
    } catch (error) {
      console.error('Failed to start MSW worker', error);
    }
  }

  const rootElement = document.querySelector('#root');
  if (!rootElement) {
    throw new Error(
      'Root element "#root" not found in the document. Check index.html.',
    );
  }

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </QueryClientProvider>
    </React.StrictMode>,
  );
}

void bootstrap();
